<template>
	<div class="Idioma-popup">
		<van-popup v-model="isShow">
			<div class='ant-modal-content'>
				<div class="ant-modal-header">
					<div class='ant-modal-title'>{{$t('mine._Idioma')}}</div>
				</div>
				<div class='ant-modal-body'>
					<div class="_bg01CgVbvy21yZsg5Aq0"
					@click="switchLang('pt')"
					:class="{
						_yZsg5Aq0active:$store.state._i18nLocale=='pt'
					}"
					>
						<span>Português</span>
						<div class="XmFVAcOt7YCkuEJ1j2xA cicle">
							<svg-icon className="imageNav-a" icon-class="comm_icon_gou--svgSprite:all" />
						</div>
					</div>
					
					<div class="_bg01CgVbvy21yZsg5Aq0" 
					@click="switchLang('en')"
					:class="{
						_yZsg5Aq0active:$store.state._i18nLocale=='en'
					}"
					>
						<span>English</span>
						<div class="XmFVAcOt7YCkuEJ1j2xA cicle">
							<svg-icon className="imageNav-a" icon-class="comm_icon_gou--svgSprite:all" />
						</div>
					</div>
					<div class="_bg01CgVbvy21yZsg5Aq0"
						@click="switchLang('xby')"
						:class="{
							_yZsg5Aq0active:$store.state._i18nLocale=='xby'
						}"
						>
						<span>Espanha</span>
						<div class="XmFVAcOt7YCkuEJ1j2xA cicle">
							<svg-icon className="imageNav-a" icon-class="comm_icon_gou--svgSprite:all" />
						</div>
					</div>
				</div>
			</div>
			<div @click="$emit('_remove')" class="QzRd3YqTnYxG8Latq8fW closeIcon"><img 
			src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII=" alt="." data-blur="0" data-status="loaded" class="goDRiiBsuEuXD3W1NphN"></div>
		</van-popup>
	</div>
</template>

<script>
	export default{
		props:{
			isShow:{
				type:Boolean,
				default:()=>{
					return false;
				}
			}
		},
		data() {
			return {
				
			}
		},
		methods:{
			switchLang(e='en'){
					   this.$i18n.locale = e;
					   this._i18n.locale = e;
					   // this.isShow=false;
					  this.$emit('_remove')
					  this.$vuex('_i18nLocale',e)
			},
		}
		
	}
</script>

<style >
	.ant-modal-content {
	    background-color: var(--theme-main-bg-color);
	    border: thin solid;
	    border-color: var(--theme-color-line);
	    border-radius: .2rem;
	    max-height: calc(100vh - .1rem);
	    max-height: calc(var(--vh, 1vh)*100 - .1rem);
	    overflow: auto;
	    position: static;
		width:6rem;
		padding:0 0 .1rem 0;
	}
	.Idioma-popup .van-popup {
		    background-color: initial;
	}
	.ant-modal-content .ant-modal-header {
	    background-color: var(--theme-main-bg-color);
	    border-bottom: none;
	    border-radius: .2rem .2rem 0 0;
	    padding: .2rem .3rem
	}
	.ant-modal-content .ant-modal-header .ant-modal-title {
	    color: var(--theme-text-color-darken);
	    font-size: .24rem;
	    font-weight: revert;
	    line-height: .34rem;
	    text-align: center
	}
	.ant-modal-content .ant-modal-body {
	    padding: .2rem .2rem 0 .2rem;
		position: relative;
	}
	.ant-modal-content .ant-modal-body:after {
	    background-color: var(--theme-color-line);
	    content: "";
	    height: .01rem;
	    left: 0;
	    position: absolute;
	    top: 0rem;
	    width: 100%
	}
	._bg01CgVbvy21yZsg5Aq0{
		height: .8rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		    border-bottom: thin solid var(--theme-color-line);
	}
	._bg01CgVbvy21yZsg5Aq0:last-child{
		border-bottom:initial
	}
	._bg01CgVbvy21yZsg5Aq0>span {
	    color: var(--theme-text-color-darken);
	    -ms-flex: 1;
	    flex: 1;
	    font-size: .22rem;
	    text-align: justify
	}
	 .XmFVAcOt7YCkuEJ1j2xA {
	    border: thin solid var(--theme-color-line);
	    border-radius: 100%;
	    font-size: .18rem;
	    height: .3rem;
	    line-height: .33rem;
	    width: .3rem
	}
	._bg01CgVbvy21yZsg5Aq0 .imageNav-a{
		display: none !important;
	}
	._yZsg5Aq0active .imageNav-a{
		display: block !important;
	}
	._yZsg5Aq0active .cicle {
	    -ms-flex-align: center;
	    -ms-flex-pack: center;
	    align-items: center;
	    background: var(--theme-primary-color);
	    border: thin solid var(--theme-primary-color);
	    color: var(--theme-primary-font-color);
	    display: -ms-flexbox;
	    display: flex;
	    justify-content: center
	}
	._yZsg5Aq0active>span{
		 color: var(--theme-primary-color)
	}

	.XmFVAcOt7YCkuEJ1j2xA i {
	    opacity: 0
	}
	.XmFVAcOt7YCkuEJ1j2xA .imageNav-a{
		width: .18rem !important;
		 color: var(--theme-primary-font-color);
		height: .18rem !important;
	}
	.QzRd3YqTnYxG8Latq8fW {
	    -ms-flex-align: center;
	    -ms-flex-pack: center;
	    align-items: center;
	    background: none;
	    border-radius: 50%;
	    display: -ms-flexbox;
	    display: flex;
	    height: .64rem;
	    justify-content: center;
		margin: 0 auto;
		margin-top: .2rem;
	    width: .64rem
	}
	.QzRd3YqTnYxG8Latq8fW img{
		width: 100%;
		height: 100%;
	}
</style>